import { t } from 'i18n';
import React, { useState, useEffect } from 'react';
import { styled, Select } from '@teko/ui';
import { useServices } from 'contexts';
import { Terminal } from 'types';
import { Province, District, Ward } from '@teko/location';

interface DropdownRegionPickerProps {
  terminals: Terminal[];
  onSelectTerminal: (index: number) => void;
}
const StyledSelect = styled(Select)`
  margin-bottom: 3px;
`;
export const DropDownRegionPicker: React.FC<DropdownRegionPickerProps> = ({
  terminals,
  onSelectTerminal,
}: DropdownRegionPickerProps) => {
  const [provinces, setProvinces] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [wards, setWards] = useState([]);
  const [provinceCode, setProvinceCode] = useState('');
  const [districtCode, setDistrictCode] = useState('');
  const [wardCode, setWardCode] = useState('');
  const availCodes = {
    wards: new Set(),
    districts: new Set(),
    provinces: new Set(),
  };
  for (const terminal of terminals) {
    availCodes.wards.add(terminal.location.ward);
    availCodes.districts.add(terminal.location.district);
    availCodes.provinces.add(terminal.location.province);
  }
  const { locationService } = useServices();
  useEffect(() => {
    // get all provinces;
    locationService.getProvinces().then((allProvinces) => {
      const allowedProvinces = allProvinces
        .filter((province: Province) => availCodes.provinces.has(province.code))
        .map((province: Province) => ({
          content: province.name,
          value: province.code,
        }));
      setProvinces(allowedProvinces);
    });
  }, []);
  useEffect(() => {
    // get list of district when province changes
    if (provinceCode)
      locationService
        .getDistrictsByProvinceCode(provinceCode)
        .then((allDistricts) => {
          const allowedDistricts = allDistricts
            .filter((district: District) =>
              availCodes.districts.has(district.code),
            )
            .map((district: District) => ({
              content: district.name,
              value: district.code,
            }));
          setDistricts(allowedDistricts);
          setWards([]);
        });
  }, [provinceCode]);
  useEffect(() => {
    // get list of wards
    if (districtCode)
      locationService.getWardsByDistrictCode(districtCode).then((allWards) => {
        const allowedWards = allWards
          .filter((ward: Ward) => availCodes.wards.has(ward.code))
          .map((ward: Ward) => ({ content: ward.name, value: ward.code }));
        setWards(allowedWards);
      });
  }, [districtCode]);
  return (
    <>
      <StyledSelect
        title={t('Chọn tỉnh/thành phố')}
        selectedValue={provinceCode}
        onChange={(code): void => {
          if (code !== provinceCode) {
            setProvinceCode(code);
            setDistrictCode('');
            setWardCode('');
          }
        }}
        items={provinces}
      />

      <StyledSelect
        title={t('Chọn quận/huyện')}
        selectedValue={districtCode}
        onChange={(code): void => {
          if (code !== districtCode) {
            setDistrictCode(code);
            setWardCode('');
          }
        }}
        items={districts}
      />

      <StyledSelect
        title={t('Chọn phường/xã')}
        selectedValue={wardCode}
        onChange={(code): void => {
          setWardCode(code);
          // use index is weird, change later
          if (onSelectTerminal)
            onSelectTerminal(
              terminals.findIndex(
                (terminal) => terminal.location.ward === code,
              ),
            );
        }}
        items={wards}
      />
    </>
  );
};
